import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CommonCategory } from "@/models/workbook";
import { useGetListFavourite } from "@/hooks/favourite/useGetListFavourite";
import CategoryFilter from "@/components/common/category-filter";

const FavouriteCategory = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [defaultCategory, setDefaultCategory] = useState<CommonCategory[]>([]);
  const [initialChecked, setInitialChecked] = useState<string[]>([]);
  const { data: favouriteResponse, isPending } = useGetListFavourite();

  useEffect(() => {
    if (!favouriteResponse || isPending) return;
    setDefaultCategory(favouriteResponse.projects);
    const categories = favouriteResponse.projects.map((item) => item.id) || [];
    const categoriesParams = searchParams.get("categories");
    if (categories.length > 0 || categoriesParams)
      setSearchParams({ categories: categoriesParams || categories.join(",") });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favouriteResponse, isPending]);

  useEffect(() => {
    if (!searchParams.get("categories")) return;
    const categories = searchParams.get("categories")?.split(",") || [];
    setInitialChecked(categories);
  }, [searchParams]);

  const handleCategoryFilter = (checkedCategory: string[]) => {
    if (checkedCategory.length === 0) {
      setSearchParams((prev) => {
        prev.delete("categories");
        return prev;
      });
      return;
    }
    setSearchParams({ categories: checkedCategory.join(",") });
  };

  return (
    <CategoryFilter
      isLoading={isPending}
      categoryOptions={defaultCategory}
      onChange={handleCategoryFilter}
      initialChecked={initialChecked}
    />
  );
};

export default FavouriteCategory;
